
export const CdrList = () => {
    return (
        <div>
            <h1>Cdr List!</h1>
        </div>
    );
};